const { __ } = wp.i18n;
const { PluginDocumentSettingPanel } = wp.editPost;
const { withSelect, select } = wp.data;
const { TextControl } = wp.components;
const { compose } = wp.compose;
const I18N_DOMAIN = 'ib-infobeans';
const EpisodeNumber = ({ meta }) => {
	let metaEpisodeNumber = meta?.episode_number ? meta?.episode_number : '';

	const updateMeta = metaKey => value => {
		wp.data.dispatch('core/editor').editPost({
			meta: {
				...meta,
				[metaKey]: value,
			},
		});
	};

	const setEpisodeNumber = e => {
		metaEpisodeNumber = e;
		updateMeta('episode_number')(metaEpisodeNumber);
	};

	return (
		<PluginDocumentSettingPanel
			name="episode-number"
			title={__('Episode Number', I18N_DOMAIN)}
			className="Episode_Number"
		>
			<>
				{
					<div>
						<div>
							<TextControl
								placeholder={__('Episode Number', I18N_DOMAIN)}
								onChange={value => setEpisodeNumber(value)}
								value={metaEpisodeNumber}
								type="number"
							/>
						</div>
					</div>
				}
			</>
		</PluginDocumentSettingPanel>
	);
};

export default compose(
	withSelect(() => {
		const meta = select('core/editor').getEditedPostAttribute('meta');
		const currentPost = select('core/editor').getCurrentPost();
		return {
			meta,
			postType: currentPost?.type,
		};
	}),
)(EpisodeNumber);
